import { uploadCroppedImage } from 'cloudinary';
import { getCroppedImg } from 'components/LogoEditor/cropImage';
import { Area } from 'react-easy-crop';

export type CropAndUploadResult = { url: string; title: string };

export class CropImageError extends Error {
    readonly code = 'CROP_FAILED' as const;
    constructor() {
        super('Failed to get cropped image blob — canvas 2D context unavailable');
        this.name = 'CropImageError';
    }
}

export class CloudinaryUploadError extends Error {
    readonly code = 'UPLOAD_FAILED' as const;
    constructor() {
        super('Cloudinary upload returned no URL');
        this.name = 'CloudinaryUploadError';
    }
}

/** Crops an image to the given pixel area + rotation, then uploads the result to Cloudinary. */
export async function cropAndUploadImage(
    image: { url: string; title: string },
    croppedAreaPixels: Area,
    rotation: number
): Promise<CropAndUploadResult> {
    const blob = await getCroppedImg(image, croppedAreaPixels, rotation);
    if (!blob) throw new CropImageError();
    const result = await uploadCroppedImage(blob, image.title);
    if (!result?.url) throw new CloudinaryUploadError();
    return { url: result.url, title: image.title };
}
